<div class="hero-section">
  <div class="hero-shell">
    <div class="hero-content">
      <h1 class="hero-title">
        <span class="hero-title-line">Procurement Management</span>
        <span class="hero-title-line hero-title-line--second">made <span class="hero-title-highlight">accountable</span>.</span>
      </h1>

      <p class="hero-description">
        From vendor to purchase order, receiving, and payment — track every purchase,
        route every approval, and know exactly what's owed.
      </p>

      <div class="hero-buttons">
        <button class="hero-btn hero-btn-primary" type="button" (click)="showRegister = true">Start free trial</button>
        <a class="hero-btn hero-btn-secondary" href="https://calendly.com/tahir-aslam-techcolleagues/meeting-with-tahir-aslam-founder-tech-colleagues?month=2026-07" target="_blank" rel="noopener noreferrer">Book a meeting</a>
      </div>
    </div>

    <div class="hero-visual" aria-hidden="true">
      <div class="po-card">
        <div class="po-card-top">
          <div class="po-icon">🧾</div>
          <div class="po-info">
            <span class="po-name">CoolBev Beverages &amp; Packaging</span>
            <span class="po-code">PO-2026-00009 · Fully Received</span>
          </div>
          <span class="po-status">Unpaid</span>
        </div>

        <div class="po-card-row">
          <span>Order total</span>
          <span class="po-amount">PKR 168,525</span>
        </div>
        <div class="po-card-row">
          <span>Outstanding</span>
          <span class="po-amount">PKR 168,525</span>
        </div>

        <div class="po-bar"><div class="po-bar-fill"></div></div>
      </div>

      <div class="floating-chip floating-chip--orders">
        <span class="floating-chip-icon">📦</span>
        <span>9 purchase orders</span>
      </div>

      <div class="floating-chip floating-chip--value">
        <span class="floating-chip-icon">💰</span>
        <span>PKR 563,745 total value</span>
      </div>
    </div>
  </div>
</div>

<app-register
  *ngIf="showRegister"
  [selectedApps]="procurementApp"
  (goBack)="showRegister = false"
></app-register>
